import React, { createContext, useContext, useState, useEffect } from 'react';

// 支持的语言列表
export const SUPPORTED_LANGUAGES = {
  zh: {
    code: 'zh',
    name: '中文',
    flag: '🇨🇳'
  },
  en: {
    code: 'en', 
    name: 'English',
    flag: '🇺🇸'
  }
};

// 语言上下文
const LanguageContext = createContext();

// 获取浏览器默认语言
const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.startsWith('zh')) return 'zh';
  return 'en';
};

// 语言提供者组件
export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    // 优先从localStorage获取，否则使用浏览器语言
    const savedLang = localStorage.getItem('decisionai-language');
    return savedLang || getBrowserLanguage();
  });

  // 切换语言
  const switchLanguage = (langCode) => {
    if (SUPPORTED_LANGUAGES[langCode]) {
      setCurrentLanguage(langCode);
      localStorage.setItem('decisionai-language', langCode);
      
      // 更新HTML lang属性
      document.documentElement.lang = langCode;
      
      // 触发自定义事件，通知其他组件语言已切换
      window.dispatchEvent(new CustomEvent('languageChanged', { 
        detail: { language: langCode } 
      }));
    }
  };

  // 获取当前语言信息
  const getCurrentLanguageInfo = () => SUPPORTED_LANGUAGES[currentLanguage];

  // 初始化时设置HTML lang属性
  useEffect(() => {
    document.documentElement.lang = currentLanguage;
  }, [currentLanguage]);

  const value = {
    currentLanguage,
    switchLanguage,
    getCurrentLanguageInfo,
    supportedLanguages: SUPPORTED_LANGUAGES,
    isZh: currentLanguage === 'zh',
    isEn: currentLanguage === 'en'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// 使用语言上下文的Hook
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
